export default __webpack_public_path__ + "3f6d6dd72dc817b8569702bf7463f89b.png";